// Generated by ReScript, PLEASE EDIT WITH CARE


var value = {
    "offers": [
      {
        "coupon_code": "COUPONDIS",
        "discount_amount": 0.0,
        "validity": "October 30 2023",
        "expired": false,
        "message": "SUCCESS",
        "title": "Coupon offers test",
        "short_description": "This is the short description",
        "long_description": "long description place",
        "auto_apply": false,
        "action_details": {
          "type": "weblink",
          "uri": "https://oms-masterbox-server.porter.in/customerapplinks/web_view?title=Coupon offers test&url=https%3A%2F%2Fporter.in%2Foffers%2Fdiscount%2Fporter1450campaign%3Fhide_header%3Dtrue",
          "title": "Coupon offers test"
        },
        "vehicle_ids": [
          1
        ]
      },
      {
        "coupon_code": "COUPONDIS",
        "discount_amount": 0.0,
        "validity": "October 30 2023",
        "expired": false,
        "message": "SUCCESS",
        "title": "Coupon offers test",
        "short_description": "This is the short description",
        "long_description": "long description place",
        "auto_apply": false,
        "action_details": {
          "type": "weblink",
          "uri": "https://oms-masterbox-server.porter.in/customerapplinks/web_view?title=Coupon offers test&url=https%3A%2F%2Fporter.in%2Foffers%2Fdiscount%2Fporter1450campaign%3Fhide_header%3Dtrue",
          "title": "Coupon offers test"
        },
        "vehicle_ids": [
          2
        ]
      }
    ],
    "is_cross_sell_enabled": true
  };

export {
  value ,
  
}
/* No side effect */
